import _ from 'lodash';
import ApolloClient from 'apollo-client';

import { Organization } from '@/store/modules/organization';
import { currentUserRoleQuery } from '@/components/pages/organization/helpers/organizationHelpers';

export function addOrganizationToCurrentUser(
  client: ApolloClient<any>,
  organization: Organization,
) {
  try {
    const query = currentUserRoleQuery;
    const currentUserId = _.get(client, 'cache.data.data.ROOT_QUERY.me.id', undefined);
    if (currentUserId == undefined) {
      return;
    }
    const data = client.readQuery({
      query,
    });
    const currentOrganizations = data.me.organizations || [];
    data.me.organizations = _.concat(currentOrganizations, organization);
    client.writeQuery({
      query,
      data,
    });
  } catch (err) {
    throw err;
  }
}
